module.exports = __webpack_public_path__ + "img/img1.50c80e8f.png";